import { render, staticRenderFns } from "./InterestAdd.vue?vue&type=template&id=4f2d17af&"
import script from "./InterestAdd.vue?vue&type=script&lang=js&"
export * from "./InterestAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports